'use strict';

var _ = require('lodash');

var currentPosition = null;

/**
* Determines if the current web application is running as a Progressive Web App (PWA).
*
* This function checks if the application is being displayed in standalone mode,
* which is a common characteristic of PWAs. It utilizes the `window.matchMedia`
* API to verify the display mode and also checks the `window.navigator.standalone`
* property for compatibility with certain browsers.
*
* @returns {boolean} - Returns `true` if the application is running as a PWA in standalone mode,
*                      otherwise returns `false`.
*/
function isPWA() {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
    || window.navigator.standalone === true;
}

/**
 * gets latitude and longitudes from navigation geolocation is browser supports it and user consented to it.
 * Otherwise, it gets latitude and longitude based on full address of connected user
 * @param {Function} geolocationFallBack fallback function when navigation location isnt enabled
 * @returns {Promise} pending promise of current user location
 */
function getGeolocation(geolocationFallBack) {
    // If you are in a PWA, use the fallback
    if (isPWA()) {
        return geolocationFallBack();
    }
    // If you're in a standard environment, continue with the geolocation API
    if (navigator.geolocation) {
        return new Promise(function (resolve) {
            if (currentPosition !== null && currentPosition.latitude && currentPosition.longitude) {
                resolve(currentPosition);
            } else {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var geometry = _.get(position, 'coords', {});
                        var location = {
                            latitude: geometry.latitude,
                            longitude: geometry.longitude,
                            isNavigationGeolocEnabled: true
                        };
                        currentPosition = location;
                        resolve(location);
                    },
                    function () {
                        // Use the fallback function for all geolocation errors
                        resolve(geolocationFallBack());
                    },
                    { enableHighAccuracy: false, maximumAge: Infinity, timeout: 1500 }
                );
            }
        });
    }

    // Fallback for no defined geolocation: rely on customer postal code
    return geolocationFallBack();
}

module.exports = { getGeolocation: getGeolocation, isPWA: isPWA };
